import React, { useState } from "react";
import Dashboard from "../../templates/Dashboard";
import ChangePassword from "../../modules/ChangePassword";

export default (props) => {
  const [loading, setLoading] = useState(false);
  return (
    <Dashboard load={loading}>
      <ChangePassword />
    </Dashboard>
  );
};
